document.addEventListener('DOMContentLoaded', () => {
  const cartIcon = document.getElementById('cart-icon');
  const cartDrawer = document.querySelector('.cart-drawer');
  const cartOverlay = document.querySelector('.cart-overlay');
  const closeCart = document.getElementById('close-cart');

  function openDrawer() {
    cartDrawer.classList.add('open');
    cartOverlay.classList.add('show');
  }

  function closeDrawer() {
    cartDrawer.classList.remove('open');
    cartOverlay.classList.remove('show');
  }

  function refreshCartDrawer() {
    Promise.all([
      fetch('/?section_id=cart-items', { cache: 'no-store' }).then(res => res.text()),
      fetch('/cart.js', { cache: 'no-store' }).then(res => res.json())
    ]).then(([html, cart]) => {
      document.querySelector('.cart-drawer-items').innerHTML = html;
      document.querySelector('.cart-drawer-footer div').textContent =
        `Summe ${formatCHF(cart.total_price)}`;

      const cartCount = document.querySelector('#cart-icon sup');
      if (cart.item_count > 0) {
        if (!cartCount) {
          const sup = document.createElement('sup');
          sup.textContent = cart.item_count;
          cartIcon.appendChild(sup);
        } else {
          cartCount.textContent = cart.item_count;
        }
      } else if (cartCount) {
        cartCount.remove();
      }

      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
    });
  }

  function formatCHF(priceInCents) {
    const value = priceInCents / 100;
    return "CHF " + value.toLocaleString("de-CH", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  cartIcon.addEventListener('click', (e) => {
    e.preventDefault();
    openDrawer();
    refreshCartDrawer();
  });

  closeCart.addEventListener('click', (e) => {
    e.preventDefault();
    closeDrawer();
  });
  cartOverlay.addEventListener('click', closeDrawer);

  document.addEventListener('click', (e) => {
    const removeButton = e.target.closest('.remove-item');
    if (!removeButton) return;

    const itemKey = removeButton.dataset.key;
    
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: itemKey, quantity: 0 }),
    })
    .then(res => res.json())
    .then(() => refreshCartDrawer());
    
  });

  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('cart') === 'open') {
    setTimeout(() => {
      openDrawer();
      refreshCartDrawer();
    }, 100);
  }

  fetch('/cart.js', { cache: 'no-store' })
    .then(res => res.json())
    .then(cart => {
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
    });
});